import useUserType from "../../../hooks/useUserType"
import { isArbitrated } from "../../../utilities/unitUtilities"
import MarkSold from "./MarkSold"
import MarkUnsold from "./MarkUnsold"

export default function MarkSoldUnsold({ unit }) {
  const { isEmployee } = useUserType()
  const isSold = unit.attributes['sold-on']

  if (isArbitrated(unit)) {
    return null
  } else if (!isSold) {
    return <MarkSold unit={unit} />
  } else if (isEmployee) {
    return <MarkUnsold unit={unit} />
  } else {
    return null
  }
}
